import { render, staticRenderFns } from "./commonLogin.vue?vue&type=template&id=5f5c9c1a&scoped=true"
import script from "./commonLogin.vue?vue&type=script&lang=ts"
export * from "./commonLogin.vue?vue&type=script&lang=ts"
import style0 from "./commonLogin.vue?vue&type=style&index=0&id=5f5c9c1a&prod&scoped=true&lang=css"
import style1 from "./commonLogin.vue?vue&type=style&index=1&id=5f5c9c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c9c1a",
  null
  
)

export default component.exports